import { render } from "./negociosPlataforma.vue?vue&type=template&id=395f9210&scoped=true"
import script from "./negociosPlataforma.vue?vue&type=script&lang=js"
export * from "./negociosPlataforma.vue?vue&type=script&lang=js"

import "./negociosPlataforma.vue?vue&type=style&index=0&id=395f9210&lang=scss&scoped=true"

import exportComponent from "C:\\xampp-80\\htdocs\\v2crmred\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-395f9210"]])

export default __exports__